<ng-container *ngIf="data.widget=='inline'; else notInline">
    <div class='w-full' *ngIf="!data.skeletonLoading; else skeletonLoadingInlineWidget">
        <div class=" relative item relative" style="width:100%;margin-bottom:10px">
            <div class="image56 r r-2x">
                <img [lazyLoad]="video['img_480x360']"
                    defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-video-image.png"
                    [alt]="video.title" class="r r-2x">
            </div>
            <div class="item-overlay opacity r r-2x bg-black">
                <a class='HVC' (click)="dialog.openYoutubeDialog(video)">
                    <i (click)="global.trackEvent('video-widget', 'Play', fromForGA)"
                        class="icon-control-play i-2x pointer text f18" title='Play'></i>
                    <i (click)="global.trackEvent('video-widget', 'Pause', fromForGA)"
                        class="icon-control-pause i-2x pointer text-active f18" title='Pause'></i>
                </a>
            </div>
        </div>
        <!-- <div class='m-l-10 flex-col-sb-fs' style='width: calc(55% - 10px)'> -->
        <div class='flex-col-sb-fs' style='flex-grow: 1;'>
            <div class='w-full'>
                <div class='flex-sb-c'>
                    <h3 class='w-full t-l'><a (click)="global.trackEvent('video-widget', 'Title', fromForGA)"
                            routerLink="/{{global.videoDetailPrefix}}/{{video.video_slug}}"
                            class="block text-ellipsis cvtitle"
                            style="max-height: 38px; overflow: hidden;">{{video.title}}&nbsp;</a></h3>
                    <div *ngIf="video.artist_slug==user.slug"
                        (click)="global.trackEvent('video-widget', 'Menu', fromForGA)"
                        class='dropdown top p-l-20 t-r p-r-5' style="width: 22px; height: 14px;">
                        <a class='fa fa-ellipsis-v text-muted font-thin p-5 f16 pointer text-muted font-thin'
                            title='More Options'></a>
                        <div class="dropdown-content bg-white f13 t-l">
                            <a class='flex-fs-c w-100p pointer'
                                (click)="global.trackEvent('video-widget-menu', 'edit', fromForGA); editVideo()">
                                <i class='fa fa-edit w-15 m-r-10'></i>Edit</a>
                        </div>
                    </div>
                </div>
                <div class='flex-fs-c'>
                    <a style="margin-bottom:20px" (click)="global.trackEvent('video-widget', 'Artist', fromForGA)"
                        routerLink="/{{video.artist_slug}}"
                        class="block text-ellipsis text-xs text-muted cvartist">{{video.name}}&nbsp;</a>
                </div>
            </div>

            <!--<div class='flex-fs-c f12 m-t-5'>
                <div class='flex-fs-c m-r-10'>
                    <i class='fa fa-play text-muted' title='Plays Count'></i>
                    <span class='m-l-5 playsCount_{{video.video_slug}}'>{{video.video_plays}}</span>
                </div>
                <div class='flex-sb-c'>
                    <img src="https://songdewnetwork.com/sgmedia/assets/images/clap-filled.png" alt="Clap" title='Claps Count' style='width: 12px;'>
                    <span class='m-l-5 clapsCountTotal_{{video.video_slug}}'>{{video.video_likes}}</span>
                </div>
            </div>-->
        </div>
    </div>
    <ng-template #skeletonLoadingInlineWidget>
        <div class="flex w-full">
            <div class="flex-c-c relative item relative" style='width: 45%; max-width: 135px;'>
                <div class="image56 r r-2x skeletonLoading"></div>
            </div>
            <div class='flex-col-sb-fs m-l-10' style='width: calc(55% - 10px)'>
                <div>
                    <div class="skeletonLoading w-70 h-15"></div>
                    <div class="skeletonLoading w-120 h-15 m-t-5"></div>
                </div>
                <div>
                    <div class="skeletonLoading w-70 h-15"></div>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>

<ng-template #notInline>
    <div class="item" *ngIf="!data.skeletonLoading; else skeletonLoadingWidget">
        <!--div class="pos-rlt">
            <div class="image56 card-img-top r r-2x">
                <img [lazyLoad]="video['img_480x360']"
                    defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-video-image.png"
                    [alt]="video.title" class="r r-2x">

                <img class="play-button" (click)="global.trackEvent('video-widget', 'Title', fromForGA)"
                    routerLink="/{{global.videoDetailPrefix}}/{{video.video_slug}}"
                    src="/assets/images/VideoListing/play.svg" alt="play">
            </div>
        </div-->
        <ng-container *ngIf="(data.from=='epk' || data.from=='epk-gallery') ;else others ">
            <div class="pos-rlt" [ngClass]="{'card-img-topp':data.from=='epk'}">
                <div class="item-overlay r r-2x ">
                    <a class='HVC playVideo' (click)="dialog.openYoutubeDialogV2(video)">
                        <i (click)="global.trackEvent('video-widget', 'Play', fromForGA)" class=" i-2x pointer text"
                            title='Play'>
                            <img class="" (click)="global.trackEvent('video-widget', 'Title', fromForGA)"
                                src="/assets/images/VideoListing/play.svg" alt="play"></i>

                    </a>
                    <!--div class="bottom p-10 flex-sb-fe">
                    <a class='icon icon-share f16 pointer' (click)="global.trackEvent('video-widget', 'Share', fromForGA); dialog.openShareDialog('video',video.video_slug,video.title,video.name,video['img_480x360'])" title='Share'></a>

                    <div class='clapsContWidget relative'>
                        <sd-clap [data]="{'for':'video','from':'widget','slug':video.video_slug,'clapsCount':video.is_like,'totalClapsCount':video.video_likes}"></sd-clap>
                    </div >
                </div-->
                </div>

                <div class="image56  r "
                    [ngStyle]="{background: 'url('+ global.getYoutubeImage(this.data?.video?.youtube_url)+') center no-repeat'}"
                    [ngClass]="{'r-profile':data.from=='epk-gallery','r-2x':data.from!=='epk-gallery','card-img-topp':data.from=='epk','card-img-top':data.from!=='epk'}">
                    <!-- <img crossorigin="anonymous" class="img-fluid"
                        [lazyLoad]="''+global.getYoutubeImage(this.data.video.youtube_url)"
                        defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-video-image.png"
                        [alt]="video.title" class="r r-2x"> -->

                </div>
            </div>

        </ng-container>
        <ng-template #others>
            <div class="pos-rlt">
                <div class="item-overlay r r-2x ">
                    <a class='HVC playVideo' (click)="dialog.openYoutubeDialogV2(video)">
                        <i (click)="global.trackEvent('video-widget', 'Play', fromForGA)" class=" i-2x pointer text"
                            title='Play'>
                            <img class="" (click)="global.trackEvent('video-widget', 'Title', fromForGA)"
                                src="/assets/images/VideoListing/play.svg" alt="play"></i>

                    </a>
                    <!--div class="bottom p-10 flex-sb-fe">
                    <a class='icon icon-share f16 pointer' (click)="global.trackEvent('video-widget', 'Share', fromForGA); dialog.openShareDialog('video',video.video_slug,video.title,video.name,video['img_480x360'])" title='Share'></a>

                    <div class='clapsContWidget relative'>
                        <sd-clap [data]="{'for':'video','from':'widget','slug':video.video_slug,'clapsCount':video.is_like,'totalClapsCount':video.video_likes}"></sd-clap>
                    </div >
                </div-->
                </div>

                <div class="image56  r "
                    [ngClass]="{'r-profile':data.from=='epk-gallery','r-2x':data.from!=='epk-gallery','card-img-topp':data.from=='epk','card-img-top':data.from!=='epk'}">
                    <img crossorigin="anonymous" [lazyLoad]="''+video['img_480x360']"
                        defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-video-image.png"
                        [alt]="video.title" class="r r-2x">
                </div>
            </div>
            <div class="padder-v">
                <div *ngIf="for=='spotlight'" class="text-ellipsis text-capitalize u-c font-bold f18 text-black">
                    {{label}}
                </div>
                <a *ngIf="for=='spotlight' && spotlight=='featured-artist'"
                    (click)="global.trackEvent('video-widget', 'Artist', fromForGA)" routerLink="/{{video.artist_slug}}"
                    class='block text-ellipsis text-capitalize'>{{video.user.profile.first_name}}&nbsp;{{video.user.profile.last_name}}</a>
                <h3 *ngIf="for=='spotlight' && spotlight=='songdew-tv'" class='w-full t-l'>
                    <a (click)="global.trackEvent('video-widget', 'Title', fromForGA)"
                        routerLink="/{{global.videoDetailPrefix}}/{{video.video_slug}}"
                        class='block text-ellipsis text-capitalize'>
                        {{video.title}}&nbsp;
                    </a>
                </h3>

                <h3 *ngIf="for!='spotlight'" class='song-text w-full t-l'>
                    <a *ngIf="data.from!=='epk-gallery'" (click)="global.trackEvent('video-widget', 'Title', fromForGA)"
                        routerLink="/{{global.videoDetailPrefix}}/{{ video.video_slug}}"
                        class='song-text block text-ellipsis text-capitalize'>
                        {{video.title}}&nbsp;
                    </a>
                </h3>
                <a *ngIf="for!='spotlight'" (click)="global.trackEvent('video-widget', 'Artist', fromForGA)"
                    routerLink="/{{video.artist_slug}}" class="block text-ellipsis text-xs text-muted">
                    <p class="singer-text">{{video.name}}</p>
                </a>
            </div>
        </ng-template>
    </div>

    <ng-template #skeletonLoadingWidget>
        <div class="item">
            <div class="pos-rlt">
                <div class="image56 skeletonLoading r r-2x">
                </div>
            </div>

            <div class="padder-v">
                <div class="skeletonLoading w-70 h-15"></div>
                <div class="skeletonLoading w-120 h-15 m-t-5"></div>
            </div>
        </div>
    </ng-template>
</ng-template>